<script setup lang="ts">
  import { computed, useId } from 'vue';
  import {
    actionsClass,
    floatingClass,
    selectionBarClass,
    textClass,
  } from './SelectionBar.css';
  import type { SelectionBarProps } from './SelectionBar.types';

  const props = withDefaults(defineProps<SelectionBarProps>(), {
    floating: false,
  });

  const uid = useId();
  const resolvedTestId = computed(
    () => props.testId ?? `ds-selection-bar-${uid}`,
  );

  const rootClasses = computed(() => [
    selectionBarClass,
    props.floating ? floatingClass : null,
  ]);
</script>

<template>
  <div :class="rootClasses" :data-testid="resolvedTestId">
    <p
      :class="textClass"
      :data-testid="`${resolvedTestId}-text`"
      role="status"
      aria-live="polite"
    >
      <slot name="text">{{ text }}</slot>
    </p>
    <div
      v-if="$slots.default"
      :class="actionsClass"
      :data-testid="`${resolvedTestId}-actions`"
    >
      <slot />
    </div>
  </div>
</template>
